/* eslint-disable */
import React, { useState } from "react";
import Container from "./Container";
import {
  Modal,
  Button, Grid, Autocomplete,
  Stack,
  TextField,
  Box,
  Checkbox,
} from "@mui/material";
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import ClearIcon from "@mui/icons-material/Clear";
import InfoIcon from "@mui/icons-material/Info";
import LockIcon from "@mui/icons-material/Lock";
import SaveIcon from "@mui/icons-material/Save";
import axios from "../../api";
import { usePopUpContext } from "../../Context/PopupMessage";
import { parseData ,getUniqueList} from "../../util";
import MendetoryIcon from "../UI/mendetoryicon";

const AddCustomerModal = (props) => {
  //Checkbox Handler
  const [userData, setUserData] = useState({ frstNm: "", lstNm: "", lgnId1: "", pwd: "", cnfrmPwd: "", email1: "", brh: "", usrGrp: "" });
  const [filterBranch, setFilterBranch] = useState({
    "keyStr": "",
    "dispStr": ""
  });
  const [filterUserGroup, setFilterUserGroup] = useState({
    "keyStr": "",
    "dispStr": ""
  });
  const [filterCompany, setFilterCompany] = useState({
    "keyStr": "",
    "dispStr": ""
  });
  React.useEffect(() => {
    console.log("Mode" + props.mode);
    if (props.mode === true) {
      setUserData(props.data);
      let parseD = parseData(props.data.fldTbl);
      setRows(parseD); console.log(props.data.fldTbl)
      setFilterBranch({
        keyStr: props?.data?.brh,
        dispStr: props?.data?.brhNm,
      });
      setFilterUserGroup({
        keyStr: props?.data?.usrGrp,
        dispStr: props?.data?.grpNm
      });
      setFilterCompany({
        keyStr: props?.data?.orgOid,
        dispStr: props?.data?.orgNm
      })
    }
    else {
      setUserData({ frstNm: "", lstNm: "", lgnId1: "", pwd: "", cnfrmPwd: "", email1: "", brh: "", usrGrp: "" });
      setFilterBranch({
        keyStr: "",
        dispStr: ""
      });
      setFilterUserGroup({
        keyStr: "",
        dispStr: ""
      });
      setFilterCompany({
        keyStr: "",
        dispStr: ""
      });
      setRows([]);
    }
  }, [props.open]);
  const apiRef = useGridApiRef();
  const { setPopupMessage, setLoading } = usePopUpContext();
  const [openBranch, setOpenBranch] = useState(false);
  const [branchOption, setBranchOption] = useState([]);
  const [row, setRows] = useState([]);
  const [openCompany, setOpenCompany] = useState(false);
  const [companyOption, setCompanyOption] = useState([])
  const [userGroupOption, setUserGroupOption] = useState([])
  const [openUserGroup, setOpenUserGroup] = useState(false);

  const handleChange = (value, target) => {
    setUserData({
      ...userData,
      [target]: value,
    });
  }
  const columns = [
    // { field: 'icon1',headerName :" ",width:1 },
    { field: 'roleDesc', headerName: "Access Right", sortable: false, width: 230 },
    {
      align: "center",
      field: 'enblRole',
      editable: false,
      width: 80,
      sortable: false,
      hideSortIcons: true,
      // headerClassName: 'checkbox-column',
      renderCell: (params) => (
        <Checkbox
          checked={params.row.enblRole === 1}
          // disableRipple
          // disableFocusRipple
          onChange={e => handleToggleSingle(params)}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      ),
      renderHeader: () => (
        <>
          Granted
        </>

      ),
    },
  ];

  const handleToggleSingle = (value, target) => {
    setRows(function (prevRows) {
      let chek = prevRows[value.id].enblRole === 1 ? 0 : 1
      prevRows[value.id].enblRole = chek
      return prevRows
    })
  }

  const getValue = (params, setValue, setOpen) => {
   
    let url = "/lookupsvc";
    setValue([])
    console.log("params:", params);
    axios
      .post(url, params)
      .then((res) => {
        setLoading(false)
        setOpen(true);
        var arrResponse = res.data.output.fldTbl;
        setValue(arrResponse);
        if(res.data.output.rtnSts===2){
          setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false)
        //  setPopupMessage({ state: true, type: "error", message: "Something went wrong please try again." })
      });
  };
  const [typingTimer, setTypingTimer] = useState();
  const SearchServiceCall = (async (newValue, parms, setOption, setOpen) => {
    // setproductSearchTextField(newValue);

    clearTimeout(typingTimer);
    if (newValue) {
      setOption([])
      const typingTimer_ = setTimeout(async () => {
        setLoading(true)
        //console.log("service call-------------------------------------------------")
        getValue(parms, setOption, setOpen);
      }, 1000);
      setTypingTimer(typingTimer_);
    } else {
      getValue({ prsMd: parms.prsMd }, setOption, setOpen);
    }
  });
  const handleGo = () => {
    console.log(userData)
    setLoading(true);

    var postData;
    const updOid = localStorage.getItem("updOid");
    if (props.mode === false) {
      postData = { prsMd: "A",
      updOid :updOid };
    } else {
      postData = { prsMd: "U",
      updOid :updOid };
    }
    postData["typ"] = "c";

    if (userData?.frstNm) {
      postData["frstNm"] = userData.frstNm;
    }
    if (userData?.lstNm) {
      postData["lstNm"] = userData.lstNm;
    }
    if (userData?.lgnId1) {
      postData["esvLgnId"] = userData.lgnId1;
    }
    if (userData?.pwd) {
      postData["esvLgnPwd"] = userData.pwd;
    }
    if (userData?.cnfrmPwd) {
      postData["cnfrmPwd"] = userData.cnfrmPwd;
    }
    if (userData?.email1) {
      postData["email1"] = userData.email1;
    }
    if (filterCompany?.keyStr !== "") {
      postData["orgOid"] = Number(filterCompany?.keyStr);
    }
    if (filterBranch?.keyStr !== "") {
      postData["brh"] = filterBranch?.keyStr;
    }
    if (filterUserGroup?.keyStr !== "") {
      postData["usrGrp"] = filterUserGroup?.keyStr;
    }
    postData["fldTbl"] = getUniqueList(row,"generated_id")
    axios.post("/usermaintenance", postData)
      .then((res) => {
        setLoading(false)
        console.log(res )
        if(res.data.output.rtnSts === 0){
          props.callback()
          handleClose()
         
        }
        if(res.data.output.rtnSts===2){
          setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
        }


      }).catch((err) => {
        setLoading(false)
        console.log(err)
        setPopupMessage({ state: true, type: "error", message: err.response.data?.Message })
      
      });
  }

  const handleAccessGo = (val) => {
    const updOid = localStorage.getItem("updOid");
    var postData = { prsMd: "G",typ:"c" ,
    updOid :updOid};
    if (val) {
      postData["usrGrp"] = val?.keyStr;
    }
    axios.post("/usermaintenance", postData)
      .then((res) => {
        setLoading(false);
        let parseD = parseData(res.data.output.fldTbl);
        setRows(parseD);

      }).catch((err) => {
        setLoading(false)
        console.log(err)
        //setPopupMessage({ state: true, type: "error", message: err.response.data?.Message })
        setRows([]);
      });
  }

  const [pass,setPass] =useState(
    true )
    const handlePassword =()=>{
      
    let newData ={pwd:"",cnfrmPwd:""}
    setUserData({
      ...userData,
      ...newData
    });
   
      setPass(false)
    }
  const handleClose=()=>{

    setPass(true)
    props.onClose()
  }

  return (
    <Modal open={props.open} onClose={handleClose} >
      <Container
        className="ixPopupLayout"
        position="absolute"
        top="20%"
        left="22.5%"
        spacing={1}
        sx={{
          overFlow: "auto", display: "flex",
          flex: 1, flexDirection: "column", justifyContent: "space-between",
          height: "400px", width: "1110px",
          borderRadius: "5px"
        }} >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2} className="ixPopupHeader"  >
          <Box className="ixPopupHeaderTitle">{props.mode === false ? "Add Customer" : "Edit Customer"} </Box>
          <Button onClick={handleClose} styletype="icon" className="ixButtonPopupHeader" >
            <ClearIcon />
          </Button>
        </Stack>
        <Stack
          direction="column"
          justifyContent="space-between"
          alignItems="center"
          spacing={2} className="ixPopupContainer" sx={{ padding: "10px" }} >

          <Grid container direction="row"
            justifyContent="space-around" spacing={2}>
            <Grid item xs={2} textAlign="right"><InfoIcon /></Grid>
            <Grid item xs={3} textAlign="left">  General Information</Grid>
            <Grid item xs={3} textAlign="right"> <LockIcon />  </Grid>
            <Grid item xs={4} textAlign="left">  Security Settings</Grid>
          </Grid>
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}>
            <Box sx={{ width: "40%", borderRight: "2px #6D92A5 solid" }}>
              <Grid container direction="row"
                justifyContent="center" spacing={2} >
                <Grid item xs={3.5} textAlign="right">First Name <MendetoryIcon /></Grid>
                <Grid item xs={8.5} textAlign="left">
                  <TextField sx={{ width: "240px" }}
                    value={userData?.frstNm}
                    onChange={(event) => handleChange(event.target.value, "frstNm")} />
                </Grid>
                <Grid item xs={3.5} textAlign="right">Last Name<MendetoryIcon /></Grid>
                <Grid item xs={8.5} textAlign="left"> <TextField sx={{ width: "240px" }} value={userData?.lstNm}
                  onChange={(event) => handleChange(event.target.value, "lstNm")} /></Grid>
                <Grid item xs={3.5} textAlign="right">Company <MendetoryIcon /></Grid>
                <Grid item xs={8.5} textAlign="left">
                  <Autocomplete sx={{ width: "240px" }}
                   noOptionsText="No items found"
                    open={openCompany}
                    value={filterCompany ? { dispStr: filterCompany?.dispStr } : null}
                    onOpen={() => {
                      getValue({ prsMd: "C" }, setCompanyOption, setOpenCompany);
                    }}
                    onClose={() => {
                      setOpenCompany(false);
                    }}
                    options={companyOption}
                    isOptionEqualToValue={(option, value) =>
                      option.dispStr === value.dispStr
                    }


                    getOptionLabel={(option) => option.dispStr}
                    onChange={(event, newValue) => {
                     
                      setFilterCompany(newValue);
                    }}
                    renderInput={(params) => <TextField 
                      value={filterCompany ? { dispStr: filterCompany?.dispStr } : null}
                      onChange={(e) =>{ SearchServiceCall(e.target.value, { prsMd: "C", srchStr: e.target.value }, setCompanyOption,
                      setOpenCompany)
                      setFilterCompany({ "keyStr": "",
                      "dispStr": e.target.value});}}


                      {...params} 
                      />}
                  /></Grid>
                <Grid item xs={3.5} textAlign="right">Branch<MendetoryIcon /></Grid>
                <Grid item xs={8.5} textAlign="left"> <Autocomplete
                 noOptionsText="No items found"
                  sx={{ width: "240px" }}
                  value={filterBranch ? { dispStr: filterBranch?.dispStr } : null}
                  open={openBranch}
                  onOpen={() => {
                    getValue({ prsMd: "B" }, setBranchOption, setOpenBranch);
                  }}
                  onClose={() => {
                    setOpenBranch(false);
                  }}
                  options={branchOption}
                  isOptionEqualToValue={(option, value) =>
                    option.dispStr === value.dispStr
                  }
                  getOptionLabel={(option) => (option ? option.dispStr : filterBranch?.dispStr)}
                  onChange={(event, newValue) => {
                    setFilterBranch(newValue)
                  }}


                  renderInput={(params) => <TextField 
                    value={filterCompany ? { dispStr: filterCompany?.dispStr } : null}
                    onChange={(e) =>{ SearchServiceCall(e.target.value, { prsMd: "B", srchStr: e.target.value }, setBranchOption,
                    setOpenBranch)
                    setFilterBranch({ "keyStr": "",
                    "dispStr": e.target.value})
                  }}
                     {...params}
                  />}
                /></Grid>
                <Grid item xs={3.5} textAlign="right">Email Addr<MendetoryIcon /></Grid>
                <Grid item xs={8.5} textAlign="left">
                  <TextField sx={{ width: "240px" }}
                    value={userData?.email1}
                    onChange={(event) => handleChange(event.target.value, "email1")} /></Grid>
              </Grid>
            </Box>
            <Box sx={{ width: "45%" }}>
              <Grid container direction="row"
                justifyContent="center" spacing={2} >
                <Grid item xs={4.5} textAlign="right">Login ID{props.mode === false ? <MendetoryIcon /> : null}</Grid>
                <Grid item xs={7.5} textAlign="left"> <TextField disabled={props.mode} sx={{ width: "240px" }} value={userData?.lgnId1}
                  onChange={(event) => handleChange(event.target.value, "lgnId1")} /></Grid>
                   <Grid item xs={4.5} textAlign="right">Password<MendetoryIcon /> </Grid>
                <Grid item xs={7.5} textAlign="left"> <TextField disabled={props.mode&&pass} sx={{ width: "240px" }} type="password" value={userData?.pwd}
                  onChange={(event) => handleChange(event.target.value, "pwd")} /></Grid>
                <Grid item xs={4.5} textAlign="right">Confirm Password <MendetoryIcon /> </Grid>
                <Grid item xs={7.5} textAlign="left"> <TextField sx={{ width: "240px" }} disabled={props.mode&&pass}type="password" value={userData?.cnfrmPwd}
                  onChange={(event) => handleChange(event.target.value, "cnfrmPwd")} /></Grid>
                    <Grid item xs={4.5} textAlign="right">User Group <MendetoryIcon /> </Grid>
                <Grid item xs={7.5} textAlign="left">
                  <Autocomplete sx={{ width: "240px" }}
                   noOptionsText="No items found"
                    open={openUserGroup}
                    value={filterUserGroup ? { dispStr: filterUserGroup?.dispStr } : null}
                    onOpen={() => {
                      getValue({ prsMd: "G", fltrStr: "c" }, setUserGroupOption, setOpenUserGroup);
                    }}
                    onClose={() => {
                      setOpenUserGroup(false);
                    }}
                    options={userGroupOption}
                    isOptionEqualToValue={(option, value) =>
                      option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => option.dispStr}
                    onChange={(event, newValue) => {
                      setFilterUserGroup(newValue ? newValue : null);
                      if (newValue) {
                        handleAccessGo(newValue);
                      }
                      else {
                        setRows([]);
                      }
                    }}

                    renderInput={(params) => <TextField 
                      
                      value={filterUserGroup ? { dispStr: filterUserGroup?.dispStr } : null} 
                      onChange={(e) => {SearchServiceCall(e.target.value, { prsMd: "G", srchStr: e.target.value }, setUserGroupOption,
                      setOpenUserGroup) 
                      setFilterUserGroup({ "keyStr": "",
                      "dispStr": e.target.value})
                    }}
                      
                      
                      {...params} />} />
                </Grid>
               
              

              </Grid>
            </Box>
            <Box sx={{ width: "35%", height: "100%" }}>
              <DataGridPro
                disableColumnReorder={true}
                apiRef={apiRef}
                headerHeight={40}
                columnBuffer={10}
                getRowId={(row) => row.generated_id}
                hideFooter={true}
                columns={columns}
                rowHeight={30}
                disableColumnMenu={true}
                rows={row}
              // onCellClick={handleCellClick}
              />
            </Box>

          </Stack>
        </Stack>
        <Stack sx={{ padding: "10px" }}
          direction="row"
          justifyContent="end"
          spacing={2}
          className="ixPopupFooter">

    {props.mode?<Button 
            onClick={() => handlePassword()}
            className="ixButtonPopup"  >
            Change password
          </Button>
:null}

          <Button styletype="icon"
            onClick={() => handleGo()}
            className="ixButtonPopup" >
            <SaveIcon />
          </Button>
        </Stack>
      </Container>
    </Modal >
  );
};

export default AddCustomerModal;
